import { render } from "./AccountDetails.vue?vue&type=template&id=0997508d&ts=true"
import script from "./AccountDetails.vue?vue&type=script&lang=ts"
export * from "./AccountDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__